import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Countdown } from "@/components/ui/Countdown";

const KEY = "gm_promo_dismissed_at";
const WEEK = 7 * 24 * 60 * 60 * 1000;

export const StickyPromoBar = ({ config, availability }) => {
  const [show, setShow] = useState(false);
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(KEY);
      const at = raw ? Number(raw) : 0;
      setShow(!at || Date.now() - at > WEEK);
    } catch (e) {
      setShow(true);
    }
  }, []);

  useEffect(() => {
    const onScroll = () => setCompact(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dismiss = () => {
    try {
      window.localStorage.setItem(KEY, String(Date.now()));
    } catch (e) {
      /* ignore */
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="promo-bar"
      className={`relative z-50 w-full ${compact ? "py-1.5" : "py-2.5"}`}
      style={{
        background: "var(--gm-navy-925)",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        transition: "padding 200ms ease",
      }}
    >
      <div className="gm-container flex flex-wrap items-center justify-center gap-x-3 gap-y-1 pr-8 text-center">
        <p className="text-[11px] leading-snug sm:text-xs" style={{ color: "var(--gm-muted)" }}>
          {config?.promo_text}{" "}
          <a
            href={config?.broker_signup_url || "#pricing"}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="promo-bar-broker-link"
            className="font-semibold text-white underline decoration-white/40 underline-offset-2 hover:decoration-white"
          >
            {config?.promo_cta_label || "Register now"}
          </a>
        </p>
        {availability?.is_open && availability?.deadline ? (
          <span className="flex items-center gap-2">
            <span
              className="hidden text-[10px] font-bold uppercase tracking-wider sm:inline"
              style={{ color: "var(--gm-muted-2)" }}
            >
              ends in
            </span>
            <Countdown
              target={availability.deadline}
              label="Free access"
              variant="compact"
              testId="promo-bar-countdown"
            />
          </span>
        ) : null}
      </div>
      <button
        type="button"
        onClick={dismiss}
        data-testid="promo-bar-dismiss-button"
        aria-label="Dismiss announcement"
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1.5 text-white/60 hover:bg-white/10 hover:text-white"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
